import { extLocalStore } from 'util/localStorage';
import { cacheKey } from 'appConstants';
import { _ssoWindow } from '../Sso';
import { userActions } from 'redux/actions';

/**
 * Handles the following data:
 * - SSO
 * - Candidate data via phone number click propagated from the extension
 */
export const handleTextRecruitData = (data, dispatch) => {
	/**
	 * Grab jwt generated via SSO flow and authenticate user
	 */
	if (data.jwt) {
		extLocalStore.setItem(cacheKey.TOKEN, data.jwt);
		dispatch(userActions.sessionInfo());
		_ssoWindow.close();
	}
	if (data.enableCandidateAdd) {
		// See: https://textrecruit.atlassian.net/browse/CE-150
		dispatch(userActions.canAddCandidate());
	} else {
		dispatch(userActions.setTextRecruitDataFromExtension(data));
	}
};
